import React, { FC } from 'react'
import { Modal as ModalComponent } from '@cse/ui'

import { ModalProps } from './modal.types'

export const Modal: FC<ModalProps> = ({ ...props }) => {
  return <ModalComponent {...props} />
}
